let Tracking = {

    fbTrackEvent: function (event, extraProperties) {
        if (typeof fbq === "undefined") {
            return false;
        }
        fbq("track", event, extraProperties);
    }

};
if (typeof module !== "undefined") {
    module.exports = Tracking;
}